<template>
  <v-menu :value="value" ref="user-menu" :nudge-bottom="44" :min-width="196" :activator="activator"
    transition="scroll-y-transition" content-class="c360-menu" left @input="$emit('input', $event)">
    <template v-if="!activator" #activator="{ attrs, on }">
      <slot name="activator" :attrs="attrs" :on="on" :open="open">
        <v-btn icon class="c360-icon" :class="[open && 'c360-icon--black']" v-bind="attrs" v-on="on">
          <c360-icon :icon="icon" />
        </v-btn>
      </slot>
    </template>
    <v-list class="pt-0">
      <slot name="extension" />
      <div v-if="user" class="pa-3">
        <p class="mb-0">
          <c360-icon icon="User_03" class="c360-menu__icon" />
          {{ user.fullName }}
        </p>
        <p class="c360-menu__email mb-0">{{ user.email }}</p>
      </div>
      <v-divider v-if="user" class="mb-1" />
      <div v-for="(group, gi) in items" :key="group.id">
        <div v-for="item, itemIndex in group" :key="item.id" :value="item.id" :id="`item-id-${itemIndex}`">

          <v-menu content-class="c360-menu" offset-x open-on-hover v-bind="isRight" close-delay="200" open-delay="200"
            :disabled="!item.children">
            <template v-slot:activator="{ attrs, on }">
              <v-list-item @click="emitClickEvent(item)" v-bind="attrs" v-on="on">
                <c360-icon :icon="item.icon" class="c360-menu__icon mr-2" />
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                <c360-icon v-if="item.children" icon="Chevron_Right" class="c360-menu__icon pl-2 mr-2" />
              </v-list-item>
            </template>

            <v-list>
              <v-list-item v-for="child, childIndex in item.children" :key="childIndex" @click="emitClickEvent(child)">
                <c360-icon :icon="child.icon" class="c360-menu__icon mr-2" />
                <v-list-item-title :id="`child-id-${childIndex}`">{{ child.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </div>
        <v-divider v-if="gi !== items.length - 1" class="my-1" />
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from 'vue';
import { C360Icon } from '../../../components/Icon';

export default Vue.extend({
  name: 'C360UserMenu',

  components: { C360Icon },

  props: {
    /**
     * Grouped menu items.
     * @type {{ title: string; icon: string; id: string }}
     */
    items: {
      type: Array,
      default: () => [],
    },

    /**
     * Current user.
     * If null user's info will not displayed.
     * @type {{ fullName: string; email: string }}
     */
    user: {
      type: Object,
    },

    /**
     * Prop for using with v-model.
     */
    value: {
      type: Boolean,
    },

    /**
     * Activator prop for vuetify's v-menu component.
     */
    activator: {
      type: String,
    },

    /**
     * Indicates if nested menu should open to left or right (default left)
     */
    alignment: {
      type: String,
      default: 'left'
    }
  },

  data() {
    return {
      open: false,
    };
  },

  computed: {
    icon() {
      return this.open ? 'Close_SM' : 'Settings_Future';
    },

    isRight() {
      return this.alignment === 'right' ? { right: true, nudgeRight: 2 } : { left: true, nudgeLeft: 2 }
    },
  },

  methods: {
    emitClickEvent(item) {
      this.$emit('item-click', item);
      this.$refs['user-menu'].save();
    },
  }
});
</script>

<style>
.c360-menu.v-menu__content,
.c360-menu.v-list {
  border: 1px solid #eeeeee;
  box-shadow: var(--c360-shadow);
  border-radius: var(--c360-radius-small);
}

.c360-menu {
  font-family: Inter, sans-serif;
  font-size: 14px !important;
  max-height: 85vh;
}

.c360-menu .v-list-item {
  min-height: 40px;
}

.c360-menu .v-list-item__title {
  font-size: 14px;
}

.c360-menu__email {
  color: #a2a2a2;
  font-size: 10px;
}

.c360-menu__icon {
  font-size: 16px !important;
}
</style>
